import { FC } from 'react'
import { Loader2 } from 'lucide-react'

/**
 * Shown by WorkspaceManager's default switch arm during hydration.
 * Prevents IntakePage from rendering with no existingFiles during the
 * deep-link cold-load window, which would let a user click Start and
 * accidentally create a duplicate workspace.
 */
export const WorkspaceLoadingSkeleton: FC = () => (
  <div className="flex-1 flex items-center justify-center p-8">
    <div className="flex flex-col items-center gap-3 text-muted-foreground">
      <Loader2 className="h-8 w-8 animate-spin" />
      <span className="text-sm">Loading workspace…</span>
    </div>
  </div>
)
